function LogOut() {
	localStorage.removeItem("token");
	window.location.href = "/";

	return true;
}

export default LogOut;
